import React, { Component } from 'react';
import styled from 'styled-components';
import {
  Text,
  Input,
  Column,
  Row,
  Button,
  Label,
  UserWarn,
  StyledSelect,
} from '../theme/index';
import { getOptions } from '../../fixture/data';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export default class AddLicenseForm extends Component {
  state = {
    third_profession: [],
  };

  render() {
    const {
      handleBlur,
      setFieldValue,
      values,
      touched,
      errors,
      togglemodal,
      handleChange,
    } = this.props;

    const nationalBoard = [
      {
        label: 'Academy of General Dentistry (AGD)',
        value: 'academyOfGeneralDentistry',
      },
      {
        label: 'Accreditation Council for Continuing Medical Education (ACCME)',
        value: 'accreditationCouncilForContinuingMedicalEducation',
      },
      {
        label:
          'The National Certification Board for Therapeutic Massage & Bodywork (NCBTMB)',
        value: 'theNationalCertificationBoardForTherapeuticMassageAndBodywork',
      },
    ];

    return (
      <Wrapper>
        <Column>
          <Text margin=".5em 0 .5em .75em" protitle>
            Add a national license number
          </Text>
          <React.Fragment>
            <Column width="75%" margin="0 auto">
              <Row
                margin=".1em 0"
                alignitems="center"
                style={{ position: 'relative' }}
              >
                <Label htmlFor="state">
                  State *
                  {touched.state && errors.state && (
                    <UserWarn>
                      <Text error>{errors.state}</Text>
                    </UserWarn>
                  )}
                  <StyledSelect
                    type="state"
                    form
                    id="state"
                    options={getOptions('state')}
                    onChange={value => {
                      setFieldValue('third_state', value);
                      this.setState({
                        third_profession: getOptions('profession', value),
                      });
                    }}
                    onBlur={handleBlur}
                    value={values.third_state}
                  />
                </Label>
                <Label htmlFor="profession">
                  Profession *
                  {touched.profession && errors.profession && (
                    <UserWarn>
                      <Text error>{errors.profession}</Text>
                    </UserWarn>
                  )}
                  <StyledSelect
                    type="third_profession"
                    form
                    id="third_profession"
                    options={this.state.third_profession}
                    onChange={value => {
                      setFieldValue('third_profession', value);
                    }}
                    onBlur={handleBlur}
                    value={values.third_profession}
                  />
                </Label>
              </Row>

              <Row
                margin=".1em 0"
                alignitems="center"
                style={{ position: 'relative' }}
              >
                <Label htmlFor="national_board">
                  National Board
                  <StyledSelect
                    large
                    type="national_board"
                    id="national_board"
                    options={nationalBoard}
                    onChange={value => {
                      setFieldValue('national_board', value);
                    }}
                    onBlur={handleBlur}
                    value={values.national_board}
                  />
                </Label>
              </Row>

              <Row
                margin=".1em 0"
                alignitems="center"
                style={{ position: 'relative' }}
              >
                <Label htmlFor="national_number">
                  National #
                  {touched.national_number && errors.national_number && (
                    <UserWarn>
                      <Text error>{errors.national_number}</Text>
                    </UserWarn>
                  )}
                  <Input
                    type="national_number"
                    id="national_number"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.national_number}
                    login
                  />
                </Label>
              </Row>
            </Column>
            <Row justifycontent="center">
              <Button add close type="button" onClick={togglemodal}>
                Close
              </Button>
              <Button type="button" onClick={togglemodal} add>
                Save
              </Button>
            </Row>
          </React.Fragment>
        </Column>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/AddNationalForm.jsx